import { disablePageScroll, enablePageScroll, addFillGapTarget, addFillGapSelector, setFillGapMethod } from 'scroll-lock';
import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Autoplay, Thumbs } from 'swiper/modules';
import "@lottiefiles/lottie-player";
import imagesLoaded from 'imagesloaded';

var Isotope = require('isotope-layout');

document.addEventListener('DOMContentLoaded', function() {
    let mm = gsap.matchMedia();
    var body = document.body;

    // HELP CHECK
    /*
	let viewportWidthEl = document.getElementById('viewport-width');
	//let viewportHeightEl = document.getElementById('viewport-height');

	function viewportCalc() {
		//let viewportHeight = window.innerHeight;
		let viewportWidth = window.innerWidth;
		//console.log(viewportWidth);
		//console.log(viewportHeight);

		//viewportWidthEl.innerText = viewportWidth;
		//viewportHeightEl.innerText = innerHeight;

		if(window.innerWidth < 576){
			viewportWidthEl.style.backgroundColor = "red";
            viewportWidthEl.innerText = 'xs';
			//viewportHeightEl.style.backgroundColor = "red";

		} else if(window.innerWidth < 768) {
			viewportWidthEl.style.backgroundColor = "orange";
            viewportWidthEl.innerText = 'sm';

			//viewportHeightEl.style.backgroundColor = "purple";

		} else if(window.innerWidth < 992) {
			viewportWidthEl.style.backgroundColor = "green";
            viewportWidthEl.innerText = 'md';
			//viewportHeightEl.style.backgroundColor = "blue";

		} else if(window.innerWidth < 1200) {
			viewportWidthEl.style.backgroundColor = "blue";
            viewportWidthEl.innerText = 'lg';
			//viewportHeightEl.style.backgroundColor = "green";

		} else if(window.innerWidth < 1400) {
			viewportWidthEl.style.backgroundColor = "purple";
            viewportWidthEl.innerText = 'xl';
			//viewportHeightEl.style.backgroundColor = "orange";
		}

		else {
			viewportWidthEl.style.backgroundColor = "black";
            viewportWidthEl.innerText = 'xxl';
			//viewportHeightEl.style.backgroundColor = "black";
		}
	}

	viewportCalc();

	window.addEventListener("resize", function(){
		viewportCalc();
	});
    */

    // APPEAR ANIMATION
    //// MAIN TEXT
    const sectionsRegularAppear = document.querySelectorAll("section:not(.--special):not(.projects-list):not(.--project-medias)");
    sectionsRegularAppear.forEach(sectionRegularAppear => {		
        var sectionRegularTextContainerChilds = sectionRegularAppear.querySelectorAll(".text-container > *");
        
        gsap.to(sectionRegularTextContainerChilds, {
            opacity:1,
            y:0,
            duration:0.6,
            stagger: 0.2,
            scrollTrigger: {
                trigger: sectionRegularAppear,
                start: "top 75%",
                //markers: true,
            }, 
        });
    })

    //// BANNER TITLE
    const bannerTitleAppear = document.querySelector(".banner-title");
    if(bannerTitleAppear) {
        gsap.to(bannerTitleAppear, {
            opacity:1,
            y:0,
            duration:0.6,
            /*
            scrollTrigger: {
                trigger: sectionRegularAppear,
                start: "top 70%",
                //markers: true,
            }, 
            */
        });
    }

    //// BANNER SERVICE
    const bannerServiceAppear = document.querySelectorAll(".banner.--service .text-container > *");
    var bannerServiceTest = document.querySelector('.page-service');
    if(bannerServiceTest) {
        gsap.to(bannerServiceAppear, {
            opacity:1,
            y:0,
            duration:0.6,
            stagger: 0.2,
            /*
            scrollTrigger: {
                trigger: sectionRegularAppear,
                start: "top 70%",
                //markers: true,
            }, 
            */
        });
    }

    //// PROJECT CARD
    const listsCardsProjectsAppear = document.querySelectorAll(".--projects-appear");
    if(listsCardsProjectsAppear) {
        listsCardsProjectsAppear.forEach(listCardsProjectsAppear => {		
            var cardsProjectsAppear = listCardsProjectsAppear.querySelectorAll(".project");
            
            gsap.to(cardsProjectsAppear, {
                opacity:1,
                duration:0.6,
                stagger: 0.2,
                scrollTrigger: {
                    trigger: listsCardsProjectsAppear,
                    start: "top 70%",
                    //markers: true,
                }, 
            });
        })
    }

    //// PROJECT LIST
    const filtersProjectsContainerAppear = document.querySelector(".filters-button-group-desktop");
    if(filtersProjectsContainerAppear) {
        const selectProjectsAppear = document.querySelector(".button-group-mobile");
        const filtersProjectsAppear = document.querySelectorAll(".filters-button-group-desktop li");

        mm.add("(max-width: 1199px)", () => {
            gsap.to(selectProjectsAppear, {
                opacity:1,
                y:0,
                duration:0.6,
                scrollTrigger: {
                    trigger: filtersProjectsContainerAppear,
                    start: "top 70%",
                    //markers: true,
                }, 
            });
        });
        
        mm.add("(min-width: 1200px)", () => {
            gsap.to(filtersProjectsAppear, {
                opacity:1,
                duration:0.6,
                stagger: 0.2,
                scrollTrigger: {
                    trigger: filtersProjectsContainerAppear,
                    start: "top 70%",
                    //markers: true,
                }, 
            });
        });

        const cardsProjectsAppear = document.querySelectorAll(".projects-grid .grid-item:nth-child(-n+8) .card > *");
        gsap.to(cardsProjectsAppear, {
            opacity:1,
            y:0,
            duration:0.2,
            stagger: 0.05,
            scrollTrigger: {
                trigger: filtersProjectsContainerAppear,
                start: "top 70%",
                //markers: true,
            }, 
        });
    
        const cardsProjectsLastAppear = document.querySelectorAll(".projects-grid .grid-item:nth-child(n+9) .card > *");
        gsap.to(cardsProjectsLastAppear, {
            opacity:1,
            duration:0.2,
            delay:1,
            scrollTrigger: {
                trigger: filtersProjectsContainerAppear,
                start: "top 70%",
                //markers: true,
            }, 
        });
    }

    //// PROJECT INTERN
    const projectMediasAppear = document.querySelectorAll(".--project-medias");  
    if(projectMediasAppear) {
        projectMediasAppear.forEach(projectMediaAppear => {	
            const projectMediasChildsAppear = projectMediaAppear.querySelectorAll("div");
	
            gsap.to(projectMediasChildsAppear, {
                opacity:1,
                duration:0.6,
                stagger: 0.2,
                scrollTrigger: {
                    trigger: projectMediaAppear,
                    start: "top 70%",
                    //markers: true,
                }, 
            });
        });
    }

    //// CONTACT
    const contactFormAppear = document.querySelector(".contact-form");
    if (contactFormAppear) {
        const contactFormChildsAppear = document.querySelectorAll(".contact-form form > div");

        gsap.to(contactFormChildsAppear, {
            opacity:1,
            y:0,
            duration:0.6,
            stagger: 0.2,
            scrollTrigger: {
                trigger: contactFormAppear,
                start: "top 70%",
                //markers: true,
            }, 
        });

        var optInContact = document.querySelector('form .--opt-in input');
        if(optInContact) {
            optInContact.addEventListener('click', () => {
                if (optInContact.checked) {
                    optInContact.classList.add('checked')
                } else {
                    optInContact.classList.remove('checked')
                }
            });
        }
    }

    //// BLOCK TESTIMONIALS
    const blockTestimonialsAppear = document.querySelector(".--block-testimonials");
    if (blockTestimonialsAppear) {
        var blockTestimonialsTL = gsap.timeline({
            scrollTrigger: {
                trigger: blockTestimonialsAppear,
                start: "top 70%",
                //markers: true,
            }, 
        });

        const blockTestimonialsTitleContainerChildsAppear = blockTestimonialsAppear.querySelectorAll(".text-container.title-container > *");
        const blockTestimonialsImgAppear = blockTestimonialsAppear.querySelectorAll(".img-container");
        const blockTestimonialsTextContainerChildsAppear = blockTestimonialsAppear.querySelectorAll(".text-container:not(.title-container) > *");
        //const blockTestimonialsNavButtonsAppear = blockTestimonialsAppear.querySelectorAll(".swiper-button");
        //const blockTestimonialsButtonAppear = blockTestimonialsAppear.querySelectorAll(".btn");

        blockTestimonialsTL.to(blockTestimonialsTitleContainerChildsAppear, {
            opacity: 1,
            y:0,
            duration:0.6,
            //stagger: 0.2,
        });

        blockTestimonialsTL.to(blockTestimonialsImgAppear, {
            opacity: 1,
            duration:0.6,
        },"-=0.2");

        blockTestimonialsTL.to(blockTestimonialsTextContainerChildsAppear, {
            opacity: 1,
            y:0,
            duration:0.6,
            //stagger: 0.2,
        },"-=0.2");

        /*
        blockTestimonialsTL.to(blockTestimonialsButtonAppear, {
            opacity: 1,
            y:0,
            duration:0.6,
        }, "-=0.9");
        */

        /*
        blockTestimonialsTL.to(blockTestimonialsNavButtonsAppear, {
            opacity: 1,
            duration:0.6,
        }, "-=0.9");
        */
    }

    const projectTestimonialsAppear = document.querySelector(".project-testimonial");
    if (projectTestimonialsAppear) {
        var projectTestimonialsTL = gsap.timeline({
            scrollTrigger: {
                trigger: projectTestimonialsAppear,
                start: "top 70%",
                //markers: true,
            }, 
        });

        const projectTestimonialsTitleContainerChildsAppear = projectTestimonialsAppear.querySelectorAll(".text-container.title-container > *");
        const projectTestimonialsImgAppear = projectTestimonialsAppear.querySelectorAll(".img-container");
        const projectTestimonialsTextContainerChildsAppear = projectTestimonialsAppear.querySelectorAll(".text-container:not(.title-container) > *");
        const projectTestimonialsButtonAppear = projectTestimonialsAppear.querySelector(".btn");


        projectTestimonialsTL.to(projectTestimonialsTitleContainerChildsAppear, {
            opacity: 1,
            y:0,
            duration:0.6,
            stagger: 0.2,
        });

        projectTestimonialsTL.to(projectTestimonialsImgAppear, {
            opacity: 1,
            duration:0.6,
        },"-=0.2");

        projectTestimonialsTL.to(projectTestimonialsTextContainerChildsAppear, {
            opacity: 1,
            y:0,
            duration:0.6,
            stagger: 0.2,
        },"-=0.2");

        projectTestimonialsTL.to(projectTestimonialsButtonAppear, {
            opacity: 1,
            y:0,
            duration:0.6,
        },"-=0.2");
    }

     //// PROJECT NEXT SLIDER
     const projectNextSliderAppear = document.querySelector(".project-next");
     if (projectNextSliderAppear) {
        const projectNextSliderTitleAppear = projectNextSliderAppear.querySelector(".title-container");
        const projectNextSliderContainerAppear = projectNextSliderAppear.querySelector(".swiper-container");

        gsap.to(projectNextSliderTitleAppear, {
            opacity:1,
            duration:0.6,
            scrollTrigger: {
                trigger: projectNextSliderAppear,
                start: "top 70%",
                //markers: true,
            }, 
        });

        gsap.to(projectNextSliderContainerAppear, {
            opacity:1,
            x:0,
            duration:0.6,
            scrollTrigger: {
                trigger: projectNextSliderAppear,
                start: "top 70%",
                //markers: true,
            }, 
        });
     }



    // LOTTIE ANIMATION
    let lottiePlayersAppear = document.getElementById("lottie-player-appear");
    if(lottiePlayersAppear) {
        lottiePlayersAppear.play();
        
        /*
        lottiePlayersAppear.addEventListener("ready", () => {
            LottieInteractivity.create({
            player:'#lottie-player-appear',
             mode:"scroll",
                actions: [
                    {
                    visibility:[0.2, 1.0],
                    type: "play"
                    }
                ]
            });
        });
        */
        

    }

    // LOGO SCROLL ANIMATION
    var navbar = document.querySelector('.navbar');
    var navbarLogo = document.getElementById('navbarLogoJS');
    var navbarLogoTagline = document.querySelector('.navbar-tagline');
    var navbarLogoPath = navbarLogo.querySelectorAll('.logo-path');
    var navbarLogoBe = navbarLogo.querySelectorAll('.logo-be');
    var navbarLogoCircle = navbarLogo.querySelector('.navbar .logo-circle');
    var navbarWhiteBgWhite = document.querySelector('.navbar.--bg-white');
    var burgerBtnLines = document.querySelectorAll('.navbar .burger-line');

    let navbarLogoAnimation = gsap.timeline({
        scrollTrigger: {
            trigger: navbarLogo,
            start: "top top",
            //markers: true,

            onEnter: function() {
                //console.log('enter');
                navbarLogoAnimation.play();
                navbarLogo.style.pointerEvents = "none";
                if(navbarLogoCircle) {
                    navbarLogoCircle.style.pointerEvents = "auto";
                }
                /*
                if(navbarWhiteBgWhite) {
                    mm.add("(min-width: 768px)", () => {
                        gsap.to(navbarWhiteBgWhite, {
                            backgroundColor: 'transparent',
                            duration:0.6,
                        });
                    });
                }
                */
                mm.add("(max-width: 767px)", () => {
                    navbar.classList.add('--responsive');
                });
            },
            onLeaveBack: function() {
                //console.log('exit');
                navbarLogoAnimation.reverse();
                navbarLogo.style.pointerEvents = "auto";
                if(navbarLogoCircle) {
                    navbarLogoCircle.style.pointerEvents = "none";  
                }
                /*
                if(navbarWhiteBgWhite) {
                    mm.add("(min-width: 768px)", () => {
                        gsap.to(navbarWhiteBgWhite, {
                            backgroundColor: '#ffffff',
                            duration:0.6,
                        });
                    });
                }
                */
                mm.add("(max-width: 767px)", () => {
                    navbar.classList.remove('--responsive');
                });            
            }
        }
    });

    mm.add("(min-width: 768px)", () => {
        navbar.classList.remove('--responsive');
    });
    
    navbarLogoAnimation.fromTo(navbarLogoPath, {
        opacity:1,
    },
    {
        duration: 0.3,
        opacity: 0,
        stagger: -0.075,
    });

    mm.add("(min-width: 768px)", () => {
        if(navbarLogoCircle) {
            navbarLogoAnimation.fromTo(navbarLogoCircle, {
                opacity:0,
            },
            {
                duration: 0.3,
                opacity: 0.63,
            });
        }
        
        navbarLogoAnimation.fromTo(navbarLogoTagline, {
            opacity:1,
        },
        {
            duration: 0.3,
            opacity: 0,
        }, '-0.075');
    });
    
    // BURGER SCROLL CHANGE COLOR
    var banner = document.querySelector('.banner');
    var navbarWhite = document.querySelector('.navbar.--text-white');

    if(navbarWhite) {
        const burgerAnimation = gsap.timeline({
            scrollTrigger: {
                trigger: banner,
                start: "bottom top+=54",
                //markers: true,

                onEnter: function() {
                    //console.log('enter');
                    burgerAnimation.play();
                },
                onLeaveBack: function() {
                    //console.log('exit');
                    burgerAnimation.reverse();
                }
            }
        });

        mm.add("(min-width: 768px)", () => {
            burgerAnimation.fromTo(burgerBtnLines, {
                backgroundColor: '#ffffff',
            },{
                backgroundColor: '#000000',
                duration: 0.075,
            });
        });
    }

    if(navbarWhiteBgWhite) {
        const navbarBgAnimation = gsap.timeline({
            scrollTrigger: {
                trigger: '#content',
                start: "top top-=90",
                //markers: true,

                onEnter: function() {
                    //console.log('enter');
                    navbarBgAnimation.play();
                    //console.log('gogo');
                },
                onLeaveBack: function() {
                    //console.log('exit');
                    navbarBgAnimation.reverse();
                }
            }
        });

        mm.add("(min-width: 768px)", () => {
            navbarBgAnimation.fromTo(navbarWhiteBgWhite, {
                backgroundColor: '#ffffff',
                //borderBottomColor: '#ffffff'
            },{
                backgroundColor: 'transparent',
                //borderBottomColor: 'transparent',
                duration: 0.075,
            });
        });
    }

    // BURGER BTN CLICK
    const burgerBtn = document.getElementById("burgerJS");
    var $scrollableElement = document.querySelector('.my-scrollable-element');

    var method = 'width'; //Available methods: none, padding, margin, width, max-width
    setFillGapMethod(method);

    burgerBtn.addEventListener('click', function() {
        if (body.classList.contains('nav-open')) { 
            body.classList.remove('nav-open');

            enablePageScroll($scrollableElement);
            document.querySelector('.main-doc').style.overflow = "auto";

        } else {
            body.classList.add('nav-open');
            disablePageScroll($scrollableElement);
            document.querySelector('.main-doc').style.overflow = "hidden";
        }
    })

    document.onkeydown = function(evt) {
		evt = evt || window.event;
		var isEscape = false;
		if ("key" in evt) {
			isEscape = (evt.key === "Escape" || evt.key === "Esc");
		} else {
			isEscape = (evt.keyCode === 27);
		}
		if (isEscape) {
			if (body.classList.contains('nav-open')) { 
				body.classList.remove('nav-open');
				//bigMenuOpen.reverse();
				enablePageScroll($scrollableElement);
                document.querySelector('.main-doc').style.overflow = "auto";
			}

            if (body.classList.contains('video-fullscreen')) { 
                body.classList.remove('video-fullscreen');
                videoContainer.style.maxWidth = "1920px";
                enablePageScroll($scrollableElement);
                document.querySelector('.main-doc').style.overflow = "auto";
                videoImmo.muted = true;
            }
		}
        
	};
    

    // PROJECTS GRID MASONRY FILTERS
    var grid = document.querySelector('.projects-grid');
    if(grid) {
        // init Isotope
        var iso = new Isotope( '.projects-grid', {
            itemSelector: '.grid-item',
            layoutMode: 'masonry',
            masonry: {
                //gutter: 48
                gutter: '.gutter-sizer',
                //horizontalOrder: true
            }
        });

        imagesLoaded( grid ).on( 'progress', function() {
            // layout Isotope after each image loads
            iso.layout();
        });
        
        var filtersElemMobile = document.querySelector('.filters-button-group-mobile .filters-select');
        var filtersElemDesktop = document.querySelector('.filters-button-group-desktop');
        
        // change is-checked class on buttons
        var buttonGroupsDesktop = document.querySelectorAll('.button-group-desktop');
        for ( var i=0, len = buttonGroupsDesktop.length; i < len; i++ ) {
            var buttonGroupDesktop = buttonGroupsDesktop[i];
        }

        const inputs = document.querySelector('.js-fake-input');
        const selects = document.querySelector('.js-select');
    
        function getSelected(){
            inputs.value = selects.options[selects.selectedIndex].text;
        }
    
        getSelected();

        mm.add("(max-width: 1199px)", () => {
            filtersElemMobile.addEventListener( 'change', function( event ) {          
                var filterValue = event.target.value;
                buttonGroupDesktop.querySelector('.is-checked').classList.remove('is-checked');
                buttonGroupDesktop.querySelector('[data-filter="' + filterValue + '"]').classList.add('is-checked');
                getSelected();
                iso.arrange({ filter: filterValue });
            });            
        });
        
        mm.add("(min-width: 1200px)", () => {
            // bind filter button click
            filtersElemDesktop.addEventListener( 'click', function( event ) {
                // only work with buttons
                if ( !matchesSelector( event.target, 'button' ) ) {
                    return;
                } 

                var filterValue = event.target.getAttribute('data-filter');
                filtersElemMobile.value = filterValue;

                inputs.value = selects.options[selects.selectedIndex].text;

                iso.arrange({ filter: filterValue });
            });
            
            radioButtonGroup( buttonGroupDesktop );
            
            function radioButtonGroup( buttonGroupDesktop ) {
                buttonGroupDesktop.addEventListener( 'click', function( event ) {
                // only work with buttons
                if ( !matchesSelector( event.target, 'button' ) ) {
                    return;
                }
                buttonGroupDesktop.querySelector('.is-checked').classList.remove('is-checked');
                event.target.classList.add('is-checked');
                });
            }  
        });   
    }

    //// CONTACT BANNER IMG CALC
    let contactBanner = document.querySelector(".banner.--contact");
    let contactBannerImg = document.querySelector(".banner.--contact .banner-pic");
    let contactBannerTitle = document.querySelector(".banner.--contact h1");
    
    function contactBannerImgCalc() {
        if(contactBanner) {
            mm.add("(min-width: 576px)", () => {
                contactBannerTitle.style.paddingRight = contactBannerImg.offsetWidth + "px";
            });

            mm.add("(max-width: 575px)", () => {
                contactBannerTitle.style.paddingRight = "0px";
            });
        }
    }

    contactBannerImgCalc();


    // XTRM IMG CALC
    //// XTRM LEFT IMG CALC
    let xtrmLeftContainer = document.querySelector(".--xtrm-left-img");
    let xtrmLeftImg = document.querySelector(".--xtrm-left-img .xtrm-img");
    
    function xtremLeftImgCalc() {
        if(xtrmLeftContainer) {
            mm.add("(min-width: 1714px)", () => {
                let xtrmLeftContainerLeft = xtrmLeftContainer.offsetLeft;
                xtrmLeftImg.style.marginLeft = ("-" + xtrmLeftContainerLeft + "px");
                xtrmLeftImg.style.marginRight = xtrmLeftContainerLeft + "px";

                xtrmLeftImg.querySelector('.img-container').style.setProperty('width', 'calc(100% + ' + xtrmLeftContainerLeft + 'px)');
            });

            mm.add("(max-width: 1713px)", () => {
                xtrmLeftImg.style.marginLeft = "";
                xtrmLeftImg.style.marginRight = "0px";

                xtrmLeftImg.querySelector('.img-container').style.setProperty('width', 'auto');
            });
        }
    }

    xtremLeftImgCalc();
    

    //// XTRM RIGHT IMG CALC
    let xtrmRightContainer = document.querySelector(".--xtrm-right-img");
    let xtrmRightImg = document.querySelector(".--xtrm-right-img .xtrm-img");
    
    function xtremRightImgCalc() {
        if(xtrmRightContainer) {
            mm.add("(min-width: 1714px)", () => {
                let xtrmRightContainerRight = xtrmRightContainer.offsetLeft;
                xtrmRightImg.style.marginRight = ("-" + xtrmRightContainerRight + "px");
                //xtrmRightImg.style.marginLeft = xtrmRightContainerRight + "px";
            
                xtrmRightImg.querySelector('.img-container').style.setProperty('width', 'calc(100% + ' + xtrmRightContainerRight + 'px)');
            });
            

            mm.add("(max-width: 1713px)", () => {
                xtrmRightImg.style.marginRight = "";
                //xtrmRightImg.style.marginLeft = "0px";

                xtrmRightImg.querySelector('.img-container').style.setProperty('width', 'auto');
            });
        }
    }

    xtremRightImgCalc();
    

    // HOMEPAGE VALUE LOOP
	const testLoopFilters = document.querySelector('.filters-loop-container .filters');
	
	if(testLoopFilters) {
		function horizontalLoop(items, config) {
			items = gsap.utils.toArray(items);
			config = config || {};
			let tl = gsap.timeline({repeat: config.repeat, paused: config.paused, defaults: {ease: "none"}, onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)}),
				length = items.length,
				startX = items[0].offsetLeft,
				times = [],
				widths = [],
				xPercents = [],
				curIndex = 0,
				pixelsPerSecond = (config.speed || 1) * 100,
				snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
				totalWidth, curX, distanceToStart, distanceToLoop, item, i;
			gsap.set(items, { // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
				xPercent: (i, el) => {
					let w = widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
					xPercents[i] = snap(parseFloat(gsap.getProperty(el, "x", "px")) / w * 100 + gsap.getProperty(el, "xPercent"));
					return xPercents[i];
				}
			});
			gsap.set(items, {x: 0});
			totalWidth = items[length-1].offsetLeft + xPercents[length-1] / 100 * widths[length-1] - startX + items[length-1].offsetWidth * gsap.getProperty(items[length-1], "scaleX") + (parseFloat(config.paddingRight) || 0);
			for (i = 0; i < length; i++) {
				item = items[i];
				curX = xPercents[i] / 100 * widths[i];
				distanceToStart = item.offsetLeft + curX - startX;
				distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
				tl.to(item, {xPercent: snap((curX - distanceToLoop) / widths[i] * 100), duration: distanceToLoop / pixelsPerSecond}, 0)
				.fromTo(item, {xPercent: snap((curX - distanceToLoop + totalWidth) / widths[i] * 100)}, {xPercent: xPercents[i], duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond, immediateRender: false}, distanceToLoop / pixelsPerSecond)
				.add("label" + i, distanceToStart / pixelsPerSecond);
				times[i] = distanceToStart / pixelsPerSecond;
			}
			function toIndex(index, vars) {
				vars = vars || {};
				(Math.abs(index - curIndex) > length / 2) && (index += index > curIndex ? -length : length); // always go in the shortest direction
				let newIndex = gsap.utils.wrap(0, length, index),
					time = times[newIndex];
				if (time > tl.time() !== index > curIndex) { // if we're wrapping the timeline's playhead, make the proper adjustments
					vars.modifiers = {time: gsap.utils.wrap(0, tl.duration())};
					time += tl.duration() * (index > curIndex ? 1 : -1);
				}
				curIndex = newIndex;
				vars.overwrite = true;
				return tl.tweenTo(time, vars);
			}
			tl.next = vars => toIndex(curIndex+1, vars);
			tl.previous = vars => toIndex(curIndex-1, vars);
			tl.current = () => curIndex;
			tl.toIndex = (index, vars) => toIndex(index, vars);
			tl.times = times;
			tl.progress(1, true).progress(0, true); // pre-render for performance
			//tl.pause();

				
			if (config.reversed) {
				tl.vars.onReverseComplete();
				tl.reverse();
			}
			return tl;
		}
        
		gsap.utils.toArray('.filters-container.--on-loop-left').forEach((line, i) => {
			const links = line.querySelectorAll("ul"),
				tl = horizontalLoop(links, {
					repeat: -1, 
					speed: 1 + i * 0.5,
					paddingRight: parseFloat(gsap.getProperty(links[0], "marginRight", "px")) // otherwise first element would be right up against the last when it loops. In this layout, the spacing is done with marginRight.
				});
		});

        gsap.utils.toArray('.filters-container.--on-loop-right').forEach((line, i) => {
			const links = line.querySelectorAll("ul"),
				tl = horizontalLoop(links, {
					repeat: -1, 
                    reversed: 'true',
					speed: 1 + i * 0.5,
					paddingRight: parseFloat(gsap.getProperty(links[0], "marginRight", "px")) // otherwise first element would be right up against the last when it loops. In this layout, the spacing is done with marginRight.
				});
		});
	}


    const swiperTestimonialsThumb = new Swiper('.swiper.--testimonials-thumb', {
        modules: [Navigation, Autoplay, Pagination, EffectFade],

        // Optional parameters
        
        loop: true,
        effect: 'fade',
        followFinger: false,
        
        //slidesPerView: 'auto',

        freeMode: true,
        watchSlidesProgress: true,
        slidesPerView: 1,

        breakpoints: {
            992: {
                slidesPerView: 'auto',
            },
        },

        //slideToClickedSlide: true,
        //centeredSlides: true,

        
        autoplay: {
            delay: 5000,
            pauseOnMouseEnter: true,
        },
        
        
        
        fadeEffect: {
            crossFade: true
        },
        
        
        
        // Navigation arrows
        /*
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        */
    });

    
    const swiperTestimonials = new Swiper('.swiper.--testimonials', {
        modules: [Navigation, Autoplay, Pagination, EffectFade, Thumbs],

        // Optional parameters
        loop: true,
        effect:'fade',
        followFinger: false,
        
        autoplay: {
            delay: 5000,
            pauseOnMouseEnter: true,
        },
        
      
        fadeEffect: {
            crossFade: true
        },

        thumbs: {
            swiper: swiperTestimonialsThumb,
        },

        autoHeight: true,

        breakpoints: {
            // when window width is >= 320px
           
            // when window width is >= 480px
            768: {
                autoHeight: false,
            },
           
          }
      
        // Navigation arrows
        /*
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        */
    });

    

    const swiperNextProject = new Swiper('.swiper.--next-project', {
        modules: [Pagination],

        // Optional parameters
        //slidesPerView: 3,
        //spaceBetween: 48,
        loop: true,
        breakpoints: {
            576: {
                slidesPerView: 2,
                spaceBetween: 24,
            },
            992: {
              slidesPerView: 3,
              spaceBetween: 48,
            },
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
    });


    // VIDEO IMMO PLAYER
    const videoImmo = document.getElementById("video-immo");
    const videoContainer = document.getElementById("videoContainerJS");

   

    if(videoImmo) {
        videoImmo.addEventListener('canplaythrough', (event) => {
            videoContainer.classList.add('loaded');
        });
    
        if(videoImmo.readyState >= 3){
            videoContainer.classList.add('loaded');
        }
    
        videoImmo.addEventListener("loadeddata", (event) => {
            videoContainer.classList.add('loaded');
        });

        mm.add("(min-width: 768px)", () => {
            videoImmo.controls = false;
        });

        mm.add("(max-width: 767px)", () => {
            videoImmo.controls = true;
            videoImmo.muted = true;
            videoImmo.play();
        });

        
        ScrollTrigger.create({
            trigger: videoImmo,
            start: "top top+=50%",
            //markers: true,
            onEnter: () => {
                videoImmo.play();
            },
            //onEnterBack: () => videoImmo.play(),
            //onLeave: () => videoImmo.pause(),
            //onLeaveBack: () => videoImmo.pause(),
        });

        
        videoImmo.addEventListener('click', function() {
            mm.add("(min-width: 1920px)", () => {
                var videoFullscreenHeight = (window.innerWidth - 200) / 2.258823529411765;
                var videoTransition = (window.innerHeight - videoFullscreenHeight) / 2;
                //console.log(videoFullscreenHeight);
                //console.log(videoTransition);

                gsap.to(window, .6, {scrollTo:{y:videoImmo, offsetY: window.innerHeight / 2 - videoFullscreenHeight / 2, autoKill:false}}, 100);

                if (body.classList.contains('video-fullscreen')) { 
                    videoContainer.style.maxWidth = "1920px";
                    body.classList.remove('video-fullscreen');
                    enablePageScroll($scrollableElement);
                    document.querySelector('.main-doc').style.overflow = "auto";
                    videoImmo.muted = true;

                } else {
                    videoContainer.style.maxWidth = "calc(100% - 200px)";
                    body.classList.add('video-fullscreen');
                    disablePageScroll($scrollableElement);
                    document.querySelector('.main-doc').style.overflow = "hidden";
                    videoImmo.muted = false;
                }
            });
        })
      
        mm.add("(min-width: 1920px)", () => {
            ///// VIDEO IMMO FULLSCREEN CURSOR
            var hoverAreas = document.querySelector('.hover-area');
            var ball = document.querySelector(".ball");
            var cursorTextSvg = document.querySelector(".--icons-container");
            var lastHoveredElement = null;

            function handleHoverEnter(e) {
                //cursorText.style.opacity = '1';
                ball.style.height = "160px";
                ball.style.width = "160px";
                cursorTextSvg.style.transform = "scale(1)";
                
                lastHoveredElement = e.target;
            }

            function handleHoverLeave(e) {
                //cursorText.style.opacity = '0';
                //ball.style.display = 'block';
                ball.style.height = "0px";
                ball.style.width = "0px";
                cursorTextSvg.style.transform = "scale(0)";

                lastHoveredElement = null;
            }

            hoverAreas.addEventListener('mouseenter', handleHoverEnter);
            hoverAreas.addEventListener('mouseleave', handleHoverLeave);

            gsap.set(".ball", {xPercent: -50, yPercent: -50});

            var ball = document.querySelector(".ball");
            var pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
            var mouse = { x: pos.x, y: pos.y };
            var speed = 0.1;
            
            var fpms = 60 / 1000;
            
            var xSet = gsap.quickSetter(ball, "x", "px");
            var ySet = gsap.quickSetter(ball, "y", "px");
            
            window.addEventListener("mousemove", e => {    
            mouse.x = e.x;
            mouse.y = e.y;  
            });
            
            gsap.ticker.add((time, deltaTime) => {
            
            var delta = deltaTime * fpms;
            var dt = 1.0 - Math.pow(1.0 - speed, delta); 
            
            pos.x += (mouse.x - pos.x) * dt;
            pos.y += (mouse.y - pos.y) * dt;
            xSet(pos.x);
            ySet(pos.y);
            });
        });
    }


    // SERVICES RESPONSIVE SLIDER
    let testServices = document.querySelector('.swiper-services-responsive');
    
    if(testServices) {
        var initSwiperHomepageServices = false;
        let swiperHomepageServices;

        mm.add("(max-width: 991px)", () => {
            if (!initSwiperHomepageServices) {
                initSwiperHomepageServices = true;

                swiperHomepageServices = new Swiper('.swiper-services-responsive', {
                    modules: [Pagination],
        
                    // Optional parameters
                    slidesPerView: 1,
                    spaceBetween: 24,
                    loop: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    breakpoints: {
                        576: {
                            slidesPerView: 1,
                            spaceBetween: 75,
                        },
                    },
                });
            } 
        });

        mm.add("(min-width: 992px)", () => {
            if (initSwiperHomepageServices) {
                swiperHomepageServices.destroy();
                initSwiperHomepageServices = false;
            }
        });
    }
  
    // IMMO SERVICES RESPONSIVE SLIDER
    let testImmo = document.querySelector('.swiper-services-immo-responsive');
    
    if(testImmo) {
        var initSwiperServicesImmo = false;
        let swiperServicesImmo;
        
        mm.add("(max-width: 991px)", () => {
            if (!initSwiperServicesImmo) {
                initSwiperServicesImmo = true;

                swiperServicesImmo = new Swiper('.swiper-services-immo-responsive', {
                    modules: [Pagination],
        
                    // Optional parameters
                    slidesPerView: 1,
                    spaceBetween: 24,
                    loop: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                });
            } 
        });

        mm.add("(min-width: 992px)", () => {
            if (initSwiperServicesImmo) {
                swiperServicesImmo.destroy();
                initSwiperServicesImmo = false;
            }
        });
    }

    // PROJECTS RESPONSIVE SLIDER
    let testProjects = document.querySelector('.swiper-projects-responsive');
    
    if(testProjects) {
        var initSwiperProject = false;
        let swiperProject;
        
        mm.add("(max-width: 991px)", () => {
            if (!initSwiperProject) {
                initSwiperProject = true;

                swiperProject = new Swiper('.swiper-projects-responsive', {
                    modules: [Pagination],
        
                    // Optional parameters
                    slidesPerView: 1,
                    spaceBetween: 24,
                    loop: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    breakpoints: {
                        576: {
                            slidesPerView: 2,
                            spaceBetween: 24,
                        },
                    },
                });
            } 
        });

        mm.add("(min-width: 992px)", () => {
            if (initSwiperProject) {
                swiperProject.destroy();
                initSwiperProject = false;
            }
        });
    }

    // HOMEPAGE RESPONSIVE PROJECTS SLIDER
    let testHomepage = document.querySelector('.homepage-projects');

    if(testHomepage) {
        let firstProjectText = document.querySelector('.swiper-projects-reponsive .--first-w-text');
        let lastProjectText = document.querySelector('.swiper-projects-reponsive .--last-w-text');
        let firstProjectImg = document.querySelector('.swiper-projects-reponsive .project.--01');
        let lastProjectImg = document.querySelector('.swiper-projects-reponsive .project.--06');
        let swiperProjectsResponsive = document.querySelector('.swiper-projects-reponsive .swiper-wrapper');

        var initSwiperHomepageProjects = false;
        let swiperHomepageProjects;        

        mm.add("(max-width: 991px)", () => {
            swiperProjectsResponsive.before(firstProjectText);
            swiperProjectsResponsive.after(lastProjectText);

            if (!initSwiperHomepageProjects) {
                initSwiperHomepageProjects = true;

                swiperHomepageProjects = new Swiper('.swiper-projects-reponsive', {
                    modules: [Pagination],
        
                    // Optional parameters
                    slidesPerView: 1,
                    spaceBetween: 24,
                    loop: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    breakpoints: {
                        576: {
                            slidesPerView: 2,
                            spaceBetween: 24,
                        },
                    },
                });
            }  

            let swiperProjectsBullets = document.querySelector('.swiper-projects-reponsive .swiper-pagination-bullets');
            lastProjectText.before(swiperProjectsBullets);   
        });

        mm.add("(min-width: 992px)", () => {
            if (initSwiperHomepageProjects) {
                swiperHomepageProjects.destroy();
                initSwiperHomepageProjects = false;
            }
        });

        mm.add("(min-width: 1200px)", () => {
            firstProjectImg.before(firstProjectText);
            lastProjectImg.after(lastProjectText);
        });
    }

    // PROJECT RESPONSIVE GALERIE SLIDER
     // SERVICES RESPONSIVE SLIDER
     let testGalerie = document.querySelector('.swiper-galerie-responsive');
    
     if(testGalerie) {
         var initSwiperProjectGalerie = false;
         let swiperProjectGalerie;
 
         mm.add("(max-width: 767px)", () => {
             if (!initSwiperProjectGalerie) {
                initSwiperProjectGalerie = true;
 
                swiperProjectGalerie = new Swiper('.swiper-galerie-responsive', {
                     modules: [Pagination],
         
                     // Optional parameters
                     slidesPerView: 1,
                     spaceBetween: 24,
                     loop: true,
                     pagination: {
                         el: '.swiper-pagination',
                         clickable: true
                     },
                 });
             } 
         });
 
         mm.add("(min-width: 768px)", () => {
             if (initSwiperProjectGalerie) {
                 swiperProjectGalerie.destroy();
                 initSwiperProjectGalerie = false;
             }
         });
     }



    //// RESIZE EVENTS
    addEventListener("resize", (event) => {
        var allProjectsImg = document.querySelectorAll('.--projects-appear .project');
        if(allProjectsImg) {
            allProjectsImg.forEach(allProjectImg => {		
                gsap.to(allProjectImg, {
                    opacity:1,
                    duration:0.6,
                    stagger: 0.2,
                });
            });
        }

        var projectGalerieImgContainer = document.querySelector('.swiper-galerie-responsive');

        if(projectGalerieImgContainer) {
            var projectsGalerieImgs = document.querySelectorAll('.case-galerie');

            gsap.to(projectGalerieImgContainer, {
                opacity:1,
                duration:0.6,
            });

            projectsGalerieImgs.forEach(projectsGalerieImg => {		
                gsap.to(projectsGalerieImg, {
                    opacity:1,
                    duration:0.6,
                    stagger: 0.2,
                });
            });
        }

        let testGalerie = document.querySelector('.swiper-galerie-responsive');
    
        if(testGalerie) {

        }

        if(testImmo) {
            if (body.classList.contains('video-fullscreen')) { 
                videoContainer.style.maxWidth = "1920px";
                body.classList.remove('video-fullscreen');
                enablePageScroll($scrollableElement);
                document.querySelector('.main-doc').style.overflow = "auto";
                videoImmo.muted = true;
            }
            
            videoImmo.addEventListener('click', function() {
                var videoFullscreenHeight = (window.innerWidth - 200) / 2.258823529411765;
                var videoTransition = (window.innerHeight - videoFullscreenHeight) / 2;
                //console.log(videoFullscreenHeight);
                //console.log(videoTransition);

                gsap.to(window, .6, {scrollTo:{y:videoImmo, offsetY: window.innerHeight / 2 - videoFullscreenHeight / 2, autoKill:false}}, 100);

                if (body.classList.contains('video-fullscreen')) { 
                    videoContainer.style.maxWidth = "1920px";
                    body.classList.remove('video-fullscreen');
                    enablePageScroll($scrollableElement);
                    document.querySelector('.main-doc').style.overflow = "auto";
                    videoImmo.muted = true;
                } else {
                    videoContainer.style.maxWidth = "calc(100% - 200px)";
                    body.classList.add('video-fullscreen');
                    disablePageScroll($scrollableElement);
                    document.querySelector('.main-doc').style.overflow = "hidden";
                    videoImmo.muted = false;
                }
            })
        }

        xtremLeftImgCalc();
        xtremRightImgCalc();  
        contactBannerImgCalc();
    });
});